import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES } from '../../constants/associations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RemoveAssociationModal({
  setRemoveCandidateObject,
  onRemoveClick,
  item,
  type,
  callObjectTitle,
  appName
}) {
  const objectLabel = OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES[type].reduce( /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  (result, el) => result.concat(`${item.properties[el]} `), '');
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": `${appName}-associations-popup-modal`,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationModals.removeAssociation"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationModals.onRemoveLabel",
        options: {
          objectLabel,
          callObjectTitle
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": `${appName}-associations-popup-modal-submit-button`,
        use: "primary",
        onClick: () => {
          setRemoveCandidateObject(null);
          onRemoveClick(item, type);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationModals.removeAssociation"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setRemoveCandidateObject(null);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationModals.cancel"
        })
      })]
    })]
  });
}
export default RemoveAssociationModal;